export const MAX_CATEGORY_ENTITIES = 20;
